export default __webpack_public_path__ + "static/media/download-report.03c0f64a.svg";